
function pricingFeedbackDialog () {
  return {
    restrict: 'E',
    templateUrl: '/core/dialogs/pricing-feedback/pricing-feedback-dialog.html?$$REVISION$$'
  }
}
export { pricingFeedbackDialog }
